// extracted by mini-css-extract-plugin
export var contentBody = "_9e-9";
export var headerImage = "_9e-2";
export var imageButton = "_9e-7";
export var imageButtonIcon = "_9e-8";
export var imageHeader = "_9e-4";
export var imageHeaderText = "_9e-5";
export var imageOverlay = "_9e-3";
export var imageTitle = "_9e-6";
export var imageWrapper = "_9e-1";
export var taskList = "_9e-a";
export var widget = "_9e-0";